import { FC, useEffect } from 'react';
import { Typography, Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { RejectedMessage, AgreeWithTerms } from 'componets/ui';

import { getDeposit } from 'features/funding/actions';

import {Paths, RequestStatus } from 'utils/constants';
import Utils from 'utils/utils';

import { useAppSelector, useAppDispatch, useCopied } from 'hooks';

import { selectUser } from 'selectors';

import { ReactComponent as CopyIcon } from 'assets/icons/copy.svg';

import s from '../index.module.scss';
import {Link} from "react-router-dom";

const BANK_DETAILS: any = {
	payment_details: 'paymentDetailsText',
	bank: 'bankText',
	beneficiary_bank_account_number: 'bankAccountNumberText',
	beneficiary_bank_address: 'bankAddressText',
	beneficiary_bank_swift_bic_code: 'bankSwiftCodeText',
	beneficiary_name: 'beneficiaryNameText',
	beneficiary_registration_number: 'beneficiaryRegistrationNumberText',
};

export const Deposit: FC = () => {
	const { status, deposit } = useAppSelector((state) => state.funding);

	const user = useAppSelector(selectUser);

	const dispatch = useAppDispatch();

	const { setIsCopied } = useCopied();

	const { t } = useTranslation();

	useEffect(() => {
		dispatch(getDeposit());
	}, [dispatch]);

	const isQuestionnaire = user.quizStatuses?.KYC && user.quizStatuses?.AML;

	if (status === RequestStatus.REJECTED) {
		return <RejectedMessage />;
	}

	return (
		<div className={s.paper}>
			{isQuestionnaire ? (
				<>
					<Typography.Title level={4} className={s.title}>
						{t('addFundsAccountText')}
					</Typography.Title>
					<Typography.Text>{t('addFundsAccountInfoText')}</Typography.Text>
					<Typography.Title level={5} className={s.tableTitle}>
						{t('bankTransferDetailsText')}
					</Typography.Title>
					<div>
						{Object.keys(BANK_DETAILS).map((item) => {
							const val =
								item === 'payment_details'
									? t('depositAccountNumber', { id: deposit[item]?.replace(/[A-z.\s]/gi, '') })
									: deposit[item];
							return (
								<div key={item} className={s.bankItem}>
									<Typography.Text type="secondary" className={s.bankItemTitle}>
										{t(BANK_DETAILS[item])}
									</Typography.Text>
									<div className={s.bankInfo}>
										<Typography.Text>{val}</Typography.Text>
										<Button
											className={s.copy}
											onClick={() => {
												setIsCopied(true);
												Utils.copyText(val);
											}}
											type="link"
											icon={<CopyIcon className="copyIcon" />}
										/>
									</div>
								</div>
							);
						})}
					</div>
				</>
			) : (
				<Typography.Text>
					{t('depositNoQuizText')}&nbsp;<Link to={Paths.KYC}>{t('depositNoQuizText2')}</Link>.
				</Typography.Text>
			)}

			{user?.accountId && !user.agreeWithTerms && <AgreeWithTerms />}
		</div>
	);
};
